import { render } from "./RoleManagement.vue?vue&type=template&id=2c06531f&scoped=true"
import script from "./RoleManagement.vue?vue&type=script&lang=js"
export * from "./RoleManagement.vue?vue&type=script&lang=js"

import "./RoleManagement.vue?vue&type=style&index=0&id=2c06531f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c06531f"

export default script